import React from 'react';
import { connect } from 'react-redux';

import MobileBuyerQuotesSlider from 'dpl/good_dog_pay/components/MobileBuyerQuotesSlider';

function MobileBuyerQuotesSliderContainer(props) {
  return <MobileBuyerQuotesSlider {...props} />;
}

export default connect(({ server }) => ({
  items: server.buyerQuotes
}))(MobileBuyerQuotesSliderContainer);
